import Vue from 'vue'

const state = {
    defaultWidget: {
        "supplierId": null,
        "supplier": null,
        "agentId": null,
        "agent": null,
        "id": null,
        "name": null,
        "editing": true,
        "isActive": true,
        "periodStart": null,
        "periodEnd": null,
        "products": [],
        "allProducts": true
    },
    currentWidgets:[],
    selectedWidgetCategory: null,
    selectedWidget: null,
}

const getters = {
    getCleanDefaultWidget: state => state.defaultWidget,
    getWidgets: state => state.currentWidgets,
    getSelectedWidgetCategory: state => state.selectedWidgetCategory,
    getSelectedWidget: state => state.selectedWidget,
}

const actions = {
    downloadVirginWidget: ({commit, rootState}, payload) => {
        return axios.get('/api/Widget/SupplierGetEmpty', {
            params: {
                supplierId: rootState.user.account.supplierId
            }
        }).then(response => {
            return response.data
        })
    },

    createWidget: ({ commit, rootState }, createWidgetObject) => {
        return axios.post('/api/Widget/SupplierCreate', {
            supplierId: rootState.user.account.supplierId,
            name: createWidgetObject.name,
            products: createWidgetObject.products
        }).then(response => {
            return response
        })
    },

    selecteWidget: ({commit}, widget) => {
        commit('SET_SELECTED_WIDGET', widget)
    },

    selectWidgetCategory: ({commit}, category) => {
        commit('SET_SELECTED_WIDGET_CATEGORY', category)
    },

    createWidgetOptions: ({ commit, rootState }, createWidgetObject) => {
        createWidgetObject.supplierId= rootState.user.account.supplierId
        return axios.post('/api/Widget/SupplierCreate', createWidgetObject).then(response => {
            return response
        })
    },

    updateWidget: ({ commit, rootState }, widget) => {
        return axios.post('/api/Widget/SupplierEdit', widget).then(response => {
            return response
        })
    },

    getAllWidgets: ({ commit, rootState }) => {
        return axios.get('/api/Widget/SupplierGetAll', {
            params: {
                supplierId: rootState.user.account.supplierId
            }
        }).then(response => {
            return response
            if(response.status == 200){
                state.currentWidgets = response.data
            }
        })
    },

    getSepcificWidget: ({dispatch, rootState}, widgetId) => {
        return axios.get('/api/Widget/SupplierGetById', {
            params: {
                widgetId: widgetId,
            }
        }).then(response => {
            if(response.status == 200){
                return response.data
            } else{
                return false
            }
        }).catch(error => {
            return false
        })
    },

    deleteWidget: ({ commit, rootState }, widget) => {
        return Vue.dialog.confirm('Delete this widget?', {okText: 'Yes', cancelText: 'No'}).then(function () {

            // proceed with delete
            return axios.post('/api/Widget/SupplierDelete', widget).then(response => {
                return response
            })

        }).catch(function () {

        });

    }
}

const mutations = {

    CREATE_WIDGET: (state, rootState) => {
        return
    },

    SET_SELECTED_WIDGET_CATEGORY: (state, category) => {
        state.selectedWidgetCategory = category
    },

    SET_SELECTED_WIDGET: (state, widget) => {
        state.selectedWidget = widget
    }

}

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/widgets.js